import React from "react";
import { Award, Globe, Server, ShieldCheck, Users } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "Enterprise-Grade Security" },
  { icon: Server, label: "Verified Spaces" },
  { icon: Globe, label: "Global Standards" },
  { icon: Users, label: "Local Support" },
  { icon: Award, label: "Built for Growth" },
];

export default function TrustSection() {
  return (
    <section className="relative bg-[#f5f8ff] py-20">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[#017bef]/0 via-[#017bef]/15 to-[#017bef]/0" />

      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <div>
          <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
            Who Powers SPACIA?
          </p>
          <h2 className="pt-[20px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[60px]">
            Built by
            <span className="block text-[#017bef]">theSOFTtribe</span>
          </h2>
          <p className="pt-6 text-[18px] leading-[29.25px] text-[#717182]">
            SPACIA is developed by theSOFTtribe, one of Africa's longest-established indigenous software companies.
          </p>
          <p className="pt-[20px] text-[16px] leading-[26px] text-[#717182]">
            Founded in 1991, theSOFTtribe has spent more than three decades designing, developing and supporting secure
            enterprise software for governments, educational institutions and private sector organisations across
            Africa.
          </p>
          <p className="pt-[20px] text-[16px] leading-[26px] text-[#717182]">
            That experience now powers SPACIA — a modern platform built for the way people really work, travel and live.
          </p>

          <div className="grid grid-cols-2 gap-[12px] pt-10 sm:grid-cols-3">
            {BADGES.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-2.5 rounded-[14px] border-[1px] border-solid border-[#e5e7eb] bg-white px-[12px] py-2.5"
              >
                <Icon className="size-[18px] shrink-0 text-[#017bef]" />
                <span className="text-[12px] font-semibold leading-[15px] text-[#0a0a0a]">{label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="relative h-[360px] overflow-hidden rounded-3xl shadow-[0_8px_48px_0_rgba(0,0,0,0.1)] sm:h-[492px]">
            <img
              src="/figma-assets/home/trust-softtribe.jpg"
              alt="theSOFTtribe — enterprise software for Africa"
              className="absolute left-0 top-[-2.81%] h-[72.8%] w-full object-cover"
            />
            <div
              className="absolute inset-0"
              style={{ backgroundImage: "linear-gradient(0deg, rgba(1, 45, 110, 0.6) 0%, rgba(1, 45, 110, 0) 50%)" }}
            />
            <div className="absolute inset-x-6 bottom-6 rounded-2xl border-[1px] border-solid border-white/50 bg-white/95 px-[20px] py-[16px]">
              <p className="text-[14px] font-bold leading-5 text-[#0a0a0a]">theSOFTtribe</p>
              <p className="pt-0.5 text-[12px] leading-4 text-[#717182]">
                Building enterprise software for Africa since 1991
              </p>
            </div>
          </div>
          <div className="absolute -right-2 -top-[18px] rounded-2xl bg-[#017bef] px-[20px] py-[16px] drop-shadow-[0_8px_16px_rgba(1,123,239,0.3)] sm:-right-[16px]">
            <p className="text-[24px] font-bold leading-6 text-white">35+</p>
            <p className="pt-1 text-[12px] leading-4 text-white/70">years of enterprise software</p>
          </div>
        </div>
      </div>
    </section>
  );
}
